// extracted by mini-css-extract-plugin
module.exports = {"box":"_32d8","image":"e0e5","text":"_71b0"};